import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Brand";

export function ProtectedRoute({ children, requireAdmin = false }) {
  const { user } = useAuth();
  if (user === null) return <Loader label="Checking your session" />;
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
